import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';
import { buyingGuideArticles } from '../buyingGuideArticles';

const BuyingGuide = () => {
  return (
    <div className={styles['buying-guide-page']}>
      <div className={styles.page}>
        <section className={styles['guide-hero']}>
          <div className={styles['guide-hero__overlay']}>
            <SiteTopNav />
          </div>
        </section>

        <main className={styles['guide-main']}>
          <section className={styles['guide-intro']}>
            <p className={styles['guide-intro__eyebrow']} data-motion="copy">
              Sakura Floors Academy
            </p>
            <h1 className={styles['guide-intro__title']} data-motion="hero">
              Buying Guide
            </h1>
            <p className={styles['guide-intro__lead']} data-motion="copy">
              Choosing the right hardwood flooring involves more than selecting a color. This guide
              helps homeowners and design professionals compare construction, wood species,
              dimensions, finishes, performance, and installation requirements with confidence.
            </p>
          </section>

          {buyingGuideArticles.map((article, index) => {
            const text = (
              <div className={styles['guide-featured__text']}>
                <h2 className={styles['guide-featured__title']} data-motion="title">
                  {article.title}
                </h2>
                <p className={styles['guide-featured__excerpt']} data-motion="copy">
                  {article.excerpt}
                </p>
                <Link
                  className={styles['guide-featured__cta']}
                  to={article.to}
                  data-motion-interactive="press"
                >
                  <span className={styles['guide-featured__ctaLabel']}>Read More</span>
                </Link>
              </div>
            );
            const media = (
              <div className={styles['guide-featured__media']}>
                <img
                  className={styles['guide-featured__image']}
                  alt={article.imageAlt}
                  referrerPolicy="no-referrer"
                  src={article.image}
                />
              </div>
            );
            return (
              <section
                key={article.to}
                className={styles['guide-featured']}
                aria-label={article.label}
              >
                {index % 2 !== 0 ? (
                  <>
                    {text}
                    {media}
                  </>
                ) : (
                  <>
                    {media}
                    {text}
                  </>
                )}
              </section>
            );
          })}
        </main>
      </div>
    </div>
  );
};

export default BuyingGuide;
